export class SubscriptionsApi {
  subscribe = async (email: string, shipmentNumber: string): Promise<{ status: number; error?: string }> => {
    try {
      const res = await fetch('/api/subscriptions/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email.trim(), shipmentNumber })
      });
      
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return { status: res.status, error: errorData.error || 'Ein Fehler ist aufgetreten' };
      }
      
      return { status: res.status };
    } catch (e) {
      console.error(e);
      return { status: 500, error: 'Ein Fehler ist aufgetreten' };
    }
  };
}
